import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';
import {
  CreateMascConfig,
  EmailCertifiedConfig,
  EmailConfig,
} from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import {
  getValidationErrorMessage,
  ValidationError,
} from '@modules/campaigns/Domain/Enums/ValidationErrors';

export class CreateMascNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: CreateMascConfig) {
    super(id, NodeType.CreateMasc, position, config);
  }

  isEmptyConfig(): boolean {
    return (this.config['copyId']?.length ?? 0) === 0;
  }

  addChild(node: string): void {
    if (this.childrenNodes.length === 0) this.childrenNodes.push(node);
    else return;
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
    else return;
  }

  initNodeConfig(): void {
    (this.config as CreateMascConfig).copyId = '';
    (this.config as CreateMascConfig).replyToEmailAddresses = [];
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];
    const config = this.config as CreateMascConfig;

    if (this.isEmptyConfig()) {
      const errorMessage = getValidationErrorMessage(ValidationError.NO_COPY_IDS, {
        nodoType: 'MASC',
      });
      errors.push({ nodeId: this.id, errorMessage });
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (config.replyToEmailAddresses && config.replyToEmailAddresses.length > 0) {
      config.replyToEmailAddresses.forEach((email) => {
        if (!emailRegex.test(email)) {
          const errorMessage = getValidationErrorMessage(ValidationError.INVALID_EMAIL_FORMAT, {
            email,
            nodoType: 'MASC',
          });
          errors.push({ nodeId: this.id, errorMessage });
        }
      });
    }

    return errors;
  }

  cloneWithConfig(newConfig: Partial<CreateMascConfig>): CreateMascNode {
    const cfg = {
      ...((this.config as CreateMascConfig) || {}),
      ...newConfig,
    } as CreateMascConfig;
    const clone = new CreateMascNode(this.id, { x: this.position.x, y: this.position.y }, cfg);
    clone.childrenNodes = this.childrenNodes.slice();
    clone.parentNodes = this.parentNodes.slice();
    return clone;
  }
}
